import { Heading4 } from '@serodigital/ui-components';
import * as React from 'react';

interface IAddressProps {
  addressLine?: string;
  city?: string;
  postcode?: string;
  country?: string;
}

const keys = ['addressLine1', 'city', 'postcode', 'country'];

export function Address(props: IAddressProps) {
  /** Generate address string */
  const addressArray = keys.reduce((prevItem, nextItem) => {
    const value = props[nextItem];
    if (value) {
      prevItem.push(value);
    }
    return prevItem;
  }, []);
  return (
    <Heading4 data-qa="bee-details-address" className="p-0 m-0">
      {addressArray.length > 0 && `${addressArray.join(', ')}.`}
    </Heading4>
  );
}
